
import { defineComponent } from 'vue'
import ActionButton from '@/components/ActionButton.vue'
import { uploadTaskAttachmentService } from '@/services/task'

export default defineComponent({
  components: {
    ActionButton
  },
  inject: ['task', 'list', 'updateListTask'],
  methods: {
    handleComputerUpload () {
      this.$refs.fileInputComputer.click()
    },
    async handleFileInputChange (event: Event) {
      const target = event.target as HTMLInputElement
      const formData = new FormData()
      Object.values(target.files).forEach((file) => {
        formData.append('files', file)
      })
      const res = await uploadTaskAttachmentService(this.$route.params.boardId, this.list._id, this.task._id, formData)
      if (!res.error) {
        this.updateListTask(res.data)
        this.$emit('close')
      }
    }
  }
})
